import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  variablesBuildNumber,
  variablesLastForcedBuildNumber,
} from '/redux/selector/remoteConfig.selector';

import UpdateAlertProviderComponent from './UpdateAlertProvider';

const UpdateAlertProviderConnected = connect(
  createStructuredSelector({
    buildNumber: variablesBuildNumber,
    lastForcedBuildNumber: variablesLastForcedBuildNumber,
  }),
)(UpdateAlertProviderComponent);

export {UpdateAlertProviderConnected as UpdateAlertProvider};
